import CampaignTableFilter from './table-filters';

export default CampaignTableFilter;
